// 路由权限对比
export function recursionRouter(userRouter=[],allRouter=[]){
  var realRouter=[];
  // console.log(userRouter)
  allRouter.forEach((v,i)=>{
    // console.log(v,i)
    userRouter.forEach((item,index)=>{
      // console.log(userRouter)
      if(item.name===v.meta.name){
        if(item.children && item.children.length>0){
           v.children=recursionRouter(item.children,v.children)
        }
        realRouter.push(v)
      }
    })
  })
  
  return realRouter
}

// 指定默认路由
export function setDefaultRoute(routes){
  routes.forEach((v,i)=>{
    // console.log(v,i)
    if(v.children && v.children.length>0){
      // console.log(v.children[0].meta.name)
      v.redirect={name:v.children[0].name}
      // console.log(v)
      setDefaultRoute(v.children)
    }
  })
}